import React, { useEffect, useState } from "react";
import { Card, Badge } from "react-bootstrap";
import CustomDropdown from "~/components/widgets/CustomDropdown";
import { useSelector, useDispatch } from "react-redux";
import { updateUserWidget, updateOrgWidget } from "~/pages/User/actions";
import { withNamespaces } from "react-i18next";
import { getBirthdayInfo } from "~/store/ducks/colaboratorProfile/actionTypes";
import SpinnerNew from "~/components/SpinnerNew";
import BirthDayCard from "./BirthDayCard";
import EditableDropdown from "../EditableDropdown";

const BirthDayWidget = ({
  apagarWidget,
  widget,
  handleMouseDown,
  isResizing,
  textMove,
  textClick,
  width,
  height,
  scope,
  isAdmin,
  ...props
}) => {
  const { t } = props;
  const { isLoadingBirthday, birthdayInfo } = useSelector(
    (state) => state.colaboratorProfileReducer
  );
  const { userSettings } = useSelector((state) => state.userSettingsReducer);
  const dispatch = useDispatch();
  const [localeLanguage, setLocaleLanguage] = useState("en");

  const { configuration } = useSelector((state) => state.adminConfigReducer);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768 && configuration && configuration.mobileReady
  );

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(
        window.innerWidth < 768 && configuration && configuration.mobileReady
      );
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    dispatch(getBirthdayInfo());
  }, [dispatch]);

  useEffect(() => {
    if (userSettings?.language) {
      const language = userSettings.language.trim();
      if (["pt", "es", "en"].includes(language)) {
        setLocaleLanguage(language);
      }
    }
  }, [userSettings]);

  useEffect(() => {
    if (!widget.userConfiguration) {
      const payload = {
        id: widget.id,
        widgetId: widget.widgetId,
        userConfiguration: {
          type: ".PowerBIUserConfiguration",
          configurationId: null,
          widthSize: "6",
        },
      };
      if (scope === "org") {
        dispatch(updateOrgWidget(payload));
      } else {
        dispatch(updateUserWidget(payload));
      }
    }
  }, [widget, dispatch]);

  return (
    <div className="main-card-v2" style={{ height: height + 100 }}>
      <SpinnerNew open={isLoadingBirthday} />
      <Card bsPrefix="card-flat">
        <Card.Header className="justify-content-between">
          <h6 className="h6old">
            <i className="icon-bell mr-2" />
            {t("BirthDayWidget.title")}
          </h6>
          <h6 className="h6old">
            {textMove && t("widgets.resizeMove")}
            {textClick && t("widgets.resizeClick")}
          </h6>

          {((scope !== "org") || isAdmin) && (
            <EditableDropdown
              apagarWidget={apagarWidget}
              isMobile={isMobile}
              handleMouseDown={handleMouseDown}
              width={width}
            />
          )}
        </Card.Header>
        {!isResizing && (
          <Card.Body style={{ paddingTop: "10px" }}>
            {birthdayInfo.length > 0 ? (
              <div
                className="notificationsscroll"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "1rem",
                  maxHeight: height - 70,
                  overflowY: "auto",
                  paddingRight: "1rem",
                }}
              >
                {birthdayInfo.map((item, index) => (
                  <BirthDayCard
                    person={item}
                    key={index}
                    index={index}
                    localeLanguage={localeLanguage}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center">{t("BirthDayWidget.noData")}</div>
            )}
          </Card.Body>
        )}
      </Card>
    </div>
  );
};

export default withNamespaces()(BirthDayWidget);
